export const CAPTCHA_CLIENT_ID = '6Ld-qhwcAAAAAAe6wQuV4TqS2yLmNONnfa3yAK8T';
